import React, { useCallback, useState } from 'react'
import Badge from '@/components/Badge'
import Tooltip from '../molecules/Tooltip'
const TaxonomyBadges = ({ itemsList, isStandard }) => {
  const numberItemsVisible = 10
  const [isDisclosed, setIsDisclosed] = useState(false)
  const isDiscloseEnabled =
    numberItemsVisible > 0 && itemsList.length > numberItemsVisible
  const numberItemsHidden = itemsList.length - numberItemsVisible

  const handleClick = useCallback(
    () => setIsDisclosed(!isDisclosed),
    [isDisclosed]
  )

  const isValidForToolTipDisplay = (item, isStandard: boolean): boolean =>
    isStandard && item?.route

  const classNameIsDisclosed = (index) => {
    return index + 1 > numberItemsVisible && !isDisclosed ? 'hidden' : ''
  }

  return (
    <div className="flex flex-wrap gap-2 max-w-prose mb-2">
      {itemsList.map((item, index) => (
        <div
          className={classNameIsDisclosed(index)}
          key={index}
        >
          <Badge>
            {item?.tooltip_description ? (
              <Tooltip
                id="space"
                noListen
                className="tooltip"
                treatmentButton
                borderBottom={'1px dotted black'}
                tooltipTitle={item?.title}
                triggerText={item?.title}
                footerText={item?.title}
                footerLink={item?.tooltip_link}
                tooltipBodyText={item?.tooltip_description}
                footerLinkText={'Learn More'}
                centerTipLink={item?.route}
                centerTipLinkText="View 20+ Centers"
                showListings={isValidForToolTipDisplay(item, isStandard)}
              />
            ) : (
              item?.title || ''
            )}
          </Badge>
        </div>
      ))}
      {isDiscloseEnabled && (
        <button
          className="text-gray-800 font-medium text-sm"
          onClick={handleClick}
        >
          {isDisclosed ? 'Show fewer' : `+${numberItemsHidden} more`}
        </button>
      )}
    </div>
  )
}

export default TaxonomyBadges
